module.exports = __webpack_public_path__ + "img/linkedin.3c8afea5.svg";